module.exports = __webpack_public_path__ + "img/audio-mark1.bddc3887.png";